module.exports = __webpack_public_path__ + "static/media/Test de Ruffier Dickson.2e427cad.pdf";